//== Start add burger-menu ==//
const header = document.querySelector('.header')
const burgerBtn = document.querySelector('.header__burger')
const html = document.querySelector('html')
const menuItems = document.querySelectorAll('.header__menu a')
const links = document.querySelectorAll('.header__button')
const burgerMenu = document.querySelector('.header__main')

menuItems.forEach(item => {
  item.addEventListener('click', () => {
    header.classList.remove('open')
    burgerMenu.classList.remove('open')
    burgerBtn.classList.remove('open')
    changeHtmlOverflow('remove')
  })
})

links.forEach(link => {
  link.addEventListener('click', () => {
    burgerMenu.classList.remove('open')
    burgerBtn.classList.remove('open')
    header.classList.remove('open')
    changeHtmlOverflow('remove')
  })
})


burgerBtn.addEventListener('click', () => {
  burgerMenu.classList.toggle('open')
  burgerBtn.classList.toggle('open')
  header.classList.toggle('open')

  if (burgerMenu.classList.contains('open')) {
    changeHtmlOverflow('add')
  } else {
    changeHtmlOverflow('remove')
  }
})
//== End add burger-menu ==//


const changeHtmlOverflow = (action) => {
  if (action === 'add') {
    html.style.overflow = 'hidden'
  }
  if (action === 'remove') {
    html.style.overflow = 'inherit'
  }
}

window.addEventListener('scroll', function () {
  if (window.scrollY > 0) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});